import React, { useEffect } from 'react'
import classes from './MyStudentsTests.module.css'
import { Button, Grid, Table, Tbody, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import { useTestsStore } from '../../store/testsStore'
import MyStudentsTestsTableRecord from '../../components/MyStudentsTestsTableRecord/MyStudentsTestsTableRecord'
import TestModal from '../../components/Modals/TestModal'
import { useAccessAPI } from '../../hooks/useAccessAPI'
import TestsService from '../../API/TestsService'
import { useMyStudents } from '../../hooks/useMyStudents'
// import { useStudentsStore } from '../../store/studentsStore'

function MyStudentsTests() {
    // const my_students = useStudentsStore(state => state.my_students)
    const [tests, setTests] = useTestsStore(state => [state.tests, state.setTests])
    const { isOpen, onOpen, onClose } = useDisclosure()
    const getTests = useAccessAPI(TestsService.getTests)

    useEffect(() => {
        async function fetchTests() {
            const response = await getTests()
            if (response?.status === 200)
                setTests(response.data)
        }

        if (tests?.length < 1)
            fetchTests()
    }, [])

    useMyStudents()
    // useEffect(() => {}, my_students)

    return (
        <Grid className={classes.container}>
            <TestModal {...{isOpen, onClose, title: "Добавление зачёта"}}/>
            <Button mr='auto' onClick={onOpen}>
                Добавить зачёт
            </Button>
            {
                tests && tests?.length > 0 &&
                <div className={classes.table}>
                    <Table>
                        <Thead>
                            <Tr>
                                <Th>Имя</Th>
                                <Th>Предмет</Th>
                                <Th>Дата</Th>
                                <Th>Статус</Th>
                                <Th>Ссылка</Th>
                                <Th>Примечания</Th>
                                <Th></Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {tests.map(test => (
                                <MyStudentsTestsTableRecord 
                                    test={test}
                                    key={`test${test.id}`}
                                />
                            ))}
                        </Tbody>
                    </Table>
                </div>
            }
        </Grid>
    )
}

export default MyStudentsTests
